import React from 'react';
import Auth from 'j-toker';
import { Form, Input, Radio, Select, DatePicker, Checkbox, Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import { InputPhone, inputPhoneAntdFormValidator } from '@yuhuinc/ui-library';
import { convertPhoneNumberObjectToString } from 'ui-library/components/InputPhone/InputPhoneHelpers';
import { MoneyInput } from '@yuhuinc/ui-library';
import { getTranslatedString } from 'helpers/i18n';
import { fieldsPrototypes } from 'helpers/constants';

const { Option } = Select;
const { TextArea } = Input;

const beforeUpload = (file) => {
  const isValidFileType = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'image/gif',
    'application/pdf',
  ].includes(file.type);

  if (!isValidFileType) {
    message.error('You can only upload JPG/JPEG/PNG/GIF/PDF file types');
  }

  const isLt20M = file.size / 1024 / 1024 < 20;
  if (!isLt20M) {
    message.error('Image must smaller than 20MB!');
  }

  return isValidFileType && isLt20M;
};

const FormItemFactory = ({
  required,
  label,
  name,
  placeholder,
  prototypeOf,
  availableOptions = [],
  documents = [],
}) => {
  const requiredField = {
    required: required,
    message: getTranslatedString('requiredField'),
  };

  const inputPhoneValidationRules = [
    {
      required: required,
      message: getTranslatedString('requiredField'),
      transform(value) {
        if (value) {
          return convertPhoneNumberObjectToString(value);
        }

        return value;
      },
    },
    {
      validator: inputPhoneAntdFormValidator,
    },
  ];

  switch (prototypeOf) {
    case fieldsPrototypes.EmailField:
      return (
        <Form.Item label={label} name={name} rules={[requiredField, { type: 'email' }]}>
          <Input placeholder={placeholder} />
        </Form.Item>
      );

    case fieldsPrototypes.PhoneField:
      return (
        <Form.Item label={label} name={name} rules={inputPhoneValidationRules}>
          <InputPhone />
        </Form.Item>
      );

    case fieldsPrototypes.CurrencyField:
      return (
        <Form.Item label={label} name={name} rules={[requiredField]}>
          <MoneyInput placeholder={placeholder} />
        </Form.Item>
      );

    case fieldsPrototypes.DateField:
      return (
        <Form.Item label={label} name={name} rules={[requiredField]}>
          <DatePicker style={{ width: '100%' }} placeholder={placeholder} />
        </Form.Item>
      );

    case fieldsPrototypes.RadioButtonField:
    case fieldsPrototypes.MultipleChoiceSingleField:
      return (
        <Form.Item label={label} name={name} rules={[requiredField]}>
          <Radio.Group>
            {(availableOptions || []).map((option) => (
              <Radio key={option} value={option}>
                {option}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
      );
    case fieldsPrototypes.CheckBoxField:
    case fieldsPrototypes.MultipleChoiceMultField:
      return (
        <Form.Item label={label} name={name} rules={[requiredField]}>
          <Checkbox.Group options={availableOptions || []} />
        </Form.Item>
      );

    case fieldsPrototypes.SelectField:
      return (
        <Form.Item label={label} name={name} rules={[requiredField]}>
          <Select placeholder={placeholder}>
            {(availableOptions || []).map((option) => (
              <Option key={option} value={option}>
                {option}
              </Option>
            ))}
          </Select>
        </Form.Item>
      );

    case fieldsPrototypes.TextAreaField:
      return (
        <Form.Item label={label} name={name} rules={[requiredField]}>
          <TextArea rows={4} placeholder={placeholder} />
        </Form.Item>
      );

    case fieldsPrototypes.FileUploadField:
      return (
        <Form.Item name={name}>
          <Upload
            name="upload"
            beforeUpload={beforeUpload}
            defaultFileList={documents}
            action={`${Auth.getApiUrl()}/file_uploads`}
          >
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        </Form.Item>
      );
    case fieldsPrototypes.IncomeField:
      return (
        <Form.Item name={name} rules={[requiredField]}>
          <MoneyInput placeholder={placeholder} />
        </Form.Item>
      );

    default:
      return (
        <Form.Item label={label} name={name} rules={[requiredField]}>
          <Input placeholder={placeholder} />
        </Form.Item>
      );
  }
};

export default FormItemFactory;
